import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const projects = [{
  id: 1,
  title: "Álbum 'Fe Inquebrantable'",
  tech: "PRODUCCIÓN: CRISTIANA CONTEMPORÁNEA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_music_christian_album.png",
  link: "/PortfolioPage"
}, {
  id: 2,
  title: "Himno Corporativo 'Visión'",
  tech: "PRODUCCIÓN: EVENTOS EMPRESARIALES",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_music_corporate_anthem.png",
  link: "/PortfolioPage"
}, {
  id: 3,
  title: "Sinfonía de Cumpleaños",
  tech: "PRODUCCIÓN: REGALOS PERSONALIZADOS",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_music_birthday_gift.png",
  link: "/PortfolioPage"
}, {
  id: 4,
  title: "EP 'Luz en el Camino'",
  tech: "PRODUCCIÓN: ADORACIÓN INSPIRADORA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_music_worship_ep.png",
  link: "/PortfolioPage"
}, {
  id: 5,
  title: "Banda Sonora 'Legado'",
  tech: "PRODUCCIÓN: PROYECTOS ESPECIALES",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_music_special_project.png",
  link: "/PortfolioPage"
}, {
  id: 6,
  title: "Melodía Familiar 'Unión'",
  tech: "PRODUCCIÓN: REUNIONES FAMILIARES",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_music_family_reunion.png",
  link: "/PortfolioPage"
}];
export default function ProyectosDestacados() {
  return <section data-section-id="226492" id="proyectos-destacados" className="bg-background py-24 text-foreground">
      <div className="mx-auto max-w-[1440px] px-[5vw]">
        <div className="mb-12 flex flex-col gap-4">
          <h2 className="font-default text-3xl font-bold tracking-wider text-foreground md:text-5xl">
            Proyectos Destacados
          </h2>
          <p className="max-w-2xl text-muted-foreground font-default text-lg">
            Cada producción refleja nuestro compromiso de crear música con propósito, compartiendo mensajes de fe, esperanza e inspiración para impactar vidas de manera positiva.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, i) => <Card key={project.id} data-index={i} className="group overflow-hidden rounded-lg border border-border bg-card transition-all duration-[600ms] ease-[cubic-bezier(0.83,0,0.17,1)] hover:-translate-y-2 hover:shadow-3xl hover:shadow-primary/20">
              <div className="relative overflow-hidden">
                <AspectRatio ratio={16 / 9}>
                  <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-[600ms] ease-[cubic-bezier(0.83,0,0.17,1)] group-hover:scale-110" />
                </AspectRatio>
                <div className="pointer-events-none absolute inset-0 bg-primary/0 mix-blend-overlay transition-colors duration-[600ms] ease-[cubic-bezier(0.83,0,0.17,1)] group-hover:bg-primary/30" />
              </div>
              
              <CardContent className="flex flex-col gap-4 p-6 pt-6">
                <span className="font-mono text-[12px] tracking-[0.2em] text-secondary font-medium uppercase">
                  {project.tech}
                </span>
                <h3 className="font-default text-xl font-bold text-foreground tracking-wide">
                  {project.title}
                </h3>
                <Button asChild variant="outline" className="mt-2 w-fit border-primary bg-transparent text-primary font-default transition-all hover:bg-primary hover:text-primary-foreground hover:shadow-lg">
                  <Link to={project.link}>Ver Detalles</Link>
                </Button>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}